<template>
  <b-form enctype="multipart/form-data" @submit.prevent="submit">
    <page-header :title="cliente.nombre" subtitle="Cliente" back-to="/clientes" />

    <b-row>
      <b-col lg="12">
        <h3 class="form-h3">Datos de cliente</h3>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Nombre Comercial*">
          <b-form-input required type="text" v-model="cliente.nombre" placeholder="Nombre Comercial" />
        </b-form-group>
      </b-col>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Razón Social*">
          <b-form-input v-model="cliente.razonSocial" type="text" placeholder="Razón Social" />
        </b-form-group>
      </b-col>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Identificador fiscal*">
          <b-form-input v-model="cliente.identificadorFiscal" type="text" placeholder="Identificador fiscal" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Unidad de negocio*">
          <select-box v-model="cliente.unidadNegocioId" :options="unidadesNegocio" />
        </b-form-group>
      </b-col>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Sector*">
          <b-form-select v-model="cliente.clienteSectorId" required>
            <b-form-select-option v-for="sector in sectores" :key="sector.id" :value="sector.id">
              {{ sector.nombreSector }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="4" md="12" sm="12">
        <b-form-group label="Código de cliente*">
          <b-form-input v-model="cliente.codigoCliente" type="text" placeholder="Código del cliente" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <campo-imagen v-model="imagenes.logo" title="Logotipo" />
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col lg="12">
        <h3 class="form-h3">Representante Legal</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Nombre*">
          <b-form-input v-model="cliente.representanteLegal" type="text" placeholder="Nombre del representante legal" />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Identificador fiscal*">
          <b-form-input
            v-model="cliente.identificadorRepresentanteLegal"
            type="text"
            placeholder="Identificador fiscal del representante legal"
          />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <h3 class="form-h3">Localización</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="País*">
          <select-box required v-model="cliente.paisId" :options="opcionesPais" />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Ciudad*">
          <b-form-input v-model="cliente.ciudad" type="text" placeholder="Ciudad" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Domicilio*">
          <b-form-input v-model="cliente.domicilio" type="text" placeholder="Domicilio" />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Código Postal*">
          <b-form-input v-model="cliente.codigoPostal" type="text" placeholder="Código Postal" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Teléfono*">
          <b-form-input v-model="cliente.telefono" type="text" placeholder="Teléfono" />
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Email*">
          <b-form-input v-model="cliente.email" type="email" placeholder="Email" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col lg="12">
        <h3 class="form-h3">Contactos</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Contacto Administración*">
          <b-form-select v-model="cliente.contactoAdministracionId" required>
            <b-form-select-option v-for="contacto in contactosSelect" :key="contacto.id" :value="contacto.id">
              {{ contacto.contacto }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
      <b-col lg="6" md="12" sm="12">
        <b-form-group label="Contacto Proyecto*">
          <b-form-select v-model="cliente.contactoProyectoId" required>
            <b-form-select-option v-for="contacto in contactosSelect" :key="contacto.id" :value="contacto.id">
              {{ contacto.contacto }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-form-group>
      <tabla-contactos :contactos="contactos" :cliente-id="cliente.id" />
    </b-form-group>

    <b-row>
      <b-col>
        <p>Creado el {{ creadoEl }}</p>
      </b-col>
      <b-col>
        <botonera-edicion url-cancelar="/clientes" />
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import { mapState } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import TablaContactos from "./TablaContactos.vue";
import * as sectorApi from "@/services/sectores.js";
import * as paisApi from "@/services/paises.js";
import * as unidadNegocioApi from "@/services/unidadesNegocio.js";
import { formatDateEs } from "@/services/date";

export default {
  components: {
    TablaContactos,
  },
  props: {
    cliente: {
      type: Object,
      required: true,
    },
    imagenes: {
      type: Object,
      required: true,
    },
    pais: {
      type: Object,
      required: true,
    },
    contactos: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      sectores: [],
      contactosSelect: [],
      unidadesNegocio: [],
      paises: [],
    };
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    creadoEl() {
      return formatDateEs(this.cliente.creadoEl);
    },
    urlAutocompletarPais() {
      return "paises/autocompletar";
    },
    opcionesPais() {
      return this.paises;
    },
  },
  watch: {
    contactos: function () {
      return (this.contactosSelect = this.contactos);
    },
  },
  async mounted() {
    await Promise.all([this.listarSectores(), this.listarUnidadesNegocio(), this.cargarPaises()]);
  },
  methods: {
    submit() {
      this.$emit("submit");
    },
    async listarSectores() {
      this.sectores = await sectorApi.listar();
    },
    async listarUnidadesNegocio() {
      this.unidadesNegocio = await unidadNegocioApi.autocompletar();
    },
    async cargarPaises() {
      this.paises = await paisApi.paraCombo();
    },
  },
};
</script>
